import { format } from 'date-fns';
import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Image, Navbar, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { BiLeftArrowAlt } from "react-icons/bi";
import { HiArrowLeft } from 'react-icons/hi';
import Loader from "react-js-loader";
import Moment from 'react-moment';
import { NumericFormat } from 'react-number-format';
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import Header from "../../Layout/Header";
import SidebarMenu from "../../Layout/SidebarMenu";
import { useAppConfig } from '../../Utils/AppConfigContext';
import { getEndpointUrl, numberToRomawi } from "../../Utils/Common";
import stempelIcon from '../../icons/stempel.png';
import ttdIcon from '../../icons/ttd.png';
import BrandLogo from '../../logo.png';
import Error404 from '../Error404';

const CetakInvoice = ({ item }) => {
    const componentRef = useRef();

    const { config, loading, error, getSignatureName, getSignatureRole, getLogoUrl, getSignatureStampUrl, getSignatureUrl, getBankHolderName, getBankAccountNumber, getBankName } = useAppConfig();

    const [error404, setError404] = useState(false);

    const [isLoading, setLoading] = useState(true);

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const navigate = useNavigate();

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const params = useParams();

    const [invoice, setInvoice] = useState([]);

    const fetchDataInvoice = useCallback(async (invoice_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/invoice/${invoice_id !== undefined ? invoice_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setInvoice(json.results);
            } else {
                setError404(true);
            }

            setLoading(false);
        });
    }, []);

    useEffect(() => {
        fetchDataInvoice(params.invoice_id);
    }, [params]);


    return error404 ? <Error404 /> : (
        <>
            <div className="d-block d-sm-none d-print-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Cetak Tagihan</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
            </div>
            <div className="d-none d-sm-inline d-print-none">
                <Header />
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            <Container className="mt-4">
                <Row className="mb-3 d-print-none d-print-none">
                    <Col lg={8} md={9} sm={12} className="offset-md-2">
                        <Button variant="secondary" onClick={() => navigate(-1)} className="pe-3 d-none d-sm-inline"><BiLeftArrowAlt /> Kembali</Button>

                        <ReactToPrint
                            trigger={() => <Button variant="outline-secondary" className="mx-2">Cetak Tagihan</Button>}
                            content={() => componentRef.current}
                        />
                    </Col>
                </Row>
                {isLoading ?
                    <Row>
                        <Col className="d-flex justify-content-center mt-3 pt-5 mb-3">
                            <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                        </Col>
                    </Row> :
                    <Row>
                        <Helmet>
                            <title>INV-{invoice.customerName.toUpperCase()}</title>
                        </Helmet>
                        <Col lg={8} md={9} sm={12} className="offset-md-2 mt-5" ref={componentRef}>
                            <Row>
                                <Col>
                                    <Image src={getLogoUrl() || BrandLogo} alt="Brand Logo" fluid className="mb-3" />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col className="text-end">
                                    <strong className="text-uppercase fw-bold fs-14">INVOICE</strong>
                                </Col>
                            </Row>
                            <div className="p-3 border mt-3 rounded-3">
                                <Row className="fs-13">
                                    <Col>
                                        <span>Kepada Yth.</span><br /><strong className="text-uppercase">{invoice.customerName}</strong><br />
                                        <span>{invoice.offer.customerAddress}</span>
                                        <table className="fs-13 mt-3">
                                            <tr>
                                                <td width={140}>No Handphone</td>
                                                <td width={20}>:</td>
                                                <td>{invoice.offer.customerPhone}</td>
                                            </tr>
                                            <tr>
                                                <td>Email</td>
                                                <td>:</td>
                                                <td>{invoice.offer.customerEmail}</td>
                                            </tr>
                                        </table>
                                    </Col>
                                    <Col>
                                        <table className="fs-13">
                                            <tr>
                                                <td width={140}>No Tagihan</td>
                                                <td width={20}>:</td>
                                                <td>{`INV/${numberToRomawi(format(new Date(invoice.invoiceDate), 'MM'))}/${format(new Date(invoice.invoiceDate), 'yy')}/${invoice.id}`}</td>
                                            </tr>
                                            <tr>
                                                <td>Tanggal</td>
                                                <td>:</td>
                                                <td><Moment format="DD/MM/YYYY">{invoice.invoiceDate}</Moment></td>
                                            </tr>
                                            <tr>
                                                <td>Tempo Pembayaran</td>
                                                <td>:</td>
                                                <td><Moment format="DD/MM/YYYY">{invoice.doeDate}</Moment></td>
                                            </tr>
                                        </table>
                                    </Col>
                                </Row>
                            </div>
                            <Row className="mt-3 fs-13">
                                <Col>
                                    <table className="table table-bordered fs-13 mt-3">
                                        <tr className="bg-danger text-light">
                                            <th className="px-3">PEKERJAAN / TARGET INSPEKSI</th>
                                            <th className="text-center" width={100}>TOTAL UNIT</th>
                                            <th className="text-center" width={100}>HARGA</th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <ol className="fs-13">
                                                    {invoice.offer.items?.length > 0 && invoice.offer.items.map((item, key) => (
                                                        <li className="pb-2 pt-2" key={`item-${key}`}>
                                                            <span className="fw-bold">{`${item.brandName} - ${item.type}`}</span>, Tahun <span className="fw-bold">{item.builtYear}</span>, <br />Nopol <span className="fw-bold">{item.policeNumber}</span><br /> Lokasi {item.location}
                                                        </li>
                                                    ))}
                                                </ol>
                                                {invoice.offer.description}
                                            </td>
                                            <td className="text-center">{`${invoice.offer.items?.length} Mobil`}</td>
                                            <td className="text-center">
                                                <NumericFormat
                                                    value={invoice.amount}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    className="p-0 m-0"
                                                    prefix={'Rp'}
                                                    renderText={(value, props) => <span {...props}>{value}</span>} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <th colSpan={2} style={{ textAlign: 'right' }} className="pe-5">TOTAL :</th>
                                            <th colSpan={3} className="text-center">
                                                <NumericFormat
                                                    value={invoice.amount}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    className="bg-transparent"
                                                    prefix={'Rp'}
                                                    renderText={(value, props) => <span {...props}>{value}</span>} />
                                            </th>
                                        </tr>
                                    </table>
                                    <p><strong>Keterangan :</strong></p>
                                    <ul>
                                        <li>Pembayaran bisa dilakukan melalui rekening <strong>{getBankName() || "Bank XXX"} <u>{getBankAccountNumber() || "XXX XXXX XXXX"}</u></strong> atas nama <strong>{getBankHolderName() || "An. Xxxx Xxxxxx"}</strong></li>
                                    </ul>
                                </Col>
                            </Row>
                            <Row className="mt-5 fs-13">
                                <Col>
                                    <p className="px-5 mb-0 pb-0">Hormat Kami,</p>
                                    <div className="stempel">
                                        <Image src={getSignatureStampUrl() || stempelIcon} alt="Stempel Image" className="mx-3" width={250} />
                                    </div>
                                    <Image src={getSignatureUrl() || ttdIcon} alt="TTD Image" className="mx-3 ttd" width={150} />
                                    <p className="px-4">
                                        <span className="text-uppercase fw-medium text-decoration-underline">{getSignatureName() || "KRISMA PRIANJANI"}</span><br />
                                        <span>{getSignatureRole() || "DIREKTUR"}</span>
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                }
            </Container>
        </>
    );
}

export default CetakInvoice;
